export default __webpack_public_path__ + "static/media/example_csv_table.588d1084.png";